
import {
  DATA_PRIMARY_KEY,
  DATA_STS_KEY,
  DATA_STS_DELETE,
  APPEND,
  MATCH_BY_INDEX,
  ROW_KEY,
  PARENT_ROW_KEY
} from './constants'
import markDataUnchanged from './markDataUnChanged'

type setValueOptions = {
  markDirty: boolean
}

function dropDeletedRowsInStore (store: any) {
  const prevSRows = store.getRows({ withFilter: false })
  let sIndex = prevSRows.length
  while (sIndex--) {
    const row = prevSRows[sIndex]
    if (row.getValue(DATA_STS_KEY) === DATA_STS_DELETE) {
      store.dropRow(row)
    }
  }
}

function atomMerge (data: any, store: any, options: setValueOptions) {
  if (!store) return
  const excludeMergeKeys: Array<string> = ['changedPropertyNames', 'extendData']
  for (const field in data) {
    const nextValue = data[field]
    const prevValue = store.getTrueValue(field)
    if (excludeMergeKeys.includes(field)) continue
    if (nextValue === prevValue) continue
    store.setTrueValue(field, nextValue)
  }
}

/**
 * 为什么不先mergedata再整体刷到tablestore中去？
 * 1、tableStore整体赋值会触发reaction
 * **/
export default function (store, data, mergeStrategy) {
  const {
    clearStatus = true,
    unpersistedRowMerge = MATCH_BY_INDEX,
    dropDeletedRows = true
  } = mergeStrategy
  store.mergeStrategy = mergeStrategy
  const rootStore = store.rootStore

  if (clearStatus) {
    markDataUnchanged(data)
  }
  // dispatch subTableData
  store.tableStores?.forEach((sDescription: any) => {
    const { alias: sAlias, dataSource: sDataSource, children } = sDescription
    // 子表数据
    const sData = data[sDataSource]
    // 子表store
    const sStore = rootStore[sAlias]
    const gStores = {}
    children?.forEach((gDescription: subDescription) => {
      const { alias: gAlias, dataSource: gDataSource } = gDescription
      const gStore = rootStore[gAlias]
      gStores[gAlias] = [gDataSource, gStore]
    })
    if (dropDeletedRows) {
      dropDeletedRowsInStore(sStore)
    }
    if (sData?.length) {
      const prevSRows = sStore.getRows({ withFilter: false })
      const prevUnpersistedSRows: Array<any> = []
      const prevPersistedSRows: any = {}
      prevSRows.forEach((row: any) => {
        const rowId = row.getValue(DATA_PRIMARY_KEY)
        if (rowId) {
          prevPersistedSRows[rowId] = row
        } else {
          prevUnpersistedSRows.push(row)
        }
      })
      let sUnpersistIndex = 0
      sData.forEach((sRowData: any) => {
        let sMergeTarget = prevPersistedSRows[sRowData.id]
        if (!sMergeTarget) {
          let needAddRow = false
          if (unpersistedRowMerge === APPEND) {
            needAddRow = true
          } else if (unpersistedRowMerge === MATCH_BY_INDEX) {
            sMergeTarget = prevUnpersistedSRows[sUnpersistIndex]
            sUnpersistIndex++
            if (!sMergeTarget) {
              needAddRow = true
            }
          }
          if (needAddRow) {
            sMergeTarget = sStore.addRow({})
          }
        }

        const sRowKey = sMergeTarget.getValue(ROW_KEY)
        for (const [gDataSource, gStore] of Object.values(gStores)) {
          if (dropDeletedRows) {
            dropDeletedRowsInStore(gStore)
          }
          const prevGRows = gStore.getRows({ withFilter: false }).filter(row => row.getValue(PARENT_ROW_KEY) === sRowKey)
          const prevUnpersistedGRows = []
          const prevPersistedGRows = {}
          prevGRows.forEach((row) => {
            const rowId = row.getValue(DATA_PRIMARY_KEY)
            if (rowId) {
              prevPersistedGRows[rowId] = row
            } else {
              prevUnpersistedGRows.push(row)
            }
          })
          let gUnpersistIndex = 0
          sRowData[gDataSource]?.forEach((gRowData) => {
            let gMergeTarget = prevPersistedGRows[gRowData.id]
            if (!gMergeTarget) {
              let needAddRow = false
              if (unpersistedRowMerge === APPEND) {
                needAddRow = true
              } else if (unpersistedRowMerge === MATCH_BY_INDEX) {
                gMergeTarget = prevUnpersistedGRows[gUnpersistIndex]
                gUnpersistIndex++
                if (!gMergeTarget) needAddRow = true
              }
              if (needAddRow) {
                const sRowKey = sMergeTarget.getValue(ROW_KEY)
                gRowData[PARENT_ROW_KEY] = sRowKey
                gStore.addRow(gRowData)
                return
              }
            }
            atomMerge(gRowData, gMergeTarget, { markDirty: !clearStatus })
          })
          // 摘除孙表数据
          delete sRowData[gDataSource]
        }
        atomMerge(sRowData, sMergeTarget, { markDirty: !clearStatus })
      })
    }
    // 摘除子表数据
    delete data[sDataSource]
  })
  atomMerge(data, rootStore[store.formStore], { markDirty: !clearStatus })
}
